import React from 'react';

interface PointAnnotationIconProps {
  style?: React.CSSProperties;
}

const PointAnnotationIcon: React.FC<PointAnnotationIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Point Annotation</title>
      <g clipPath="url(#clip0)">
        <path d="M25.98 22.5v-15L12.99 0 0 7.5v15L12.99 30l12.99-7.5z" fill="#6A11EA" />
        <path d="M12.99 18.9a3.9 3.9 0 100-7.8 3.9 3.9 0 000 7.8z" fill="#FD9D52" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PointAnnotationIcon;
